// eslint-disable-next-line unused-imports/no-unused-vars
export function eventTypeGQLFields(fields) {
    return `
    name
    description
    noun
    requiredScope
    shortDescription
    verb
  `;
}
//# sourceMappingURL=eventType.fields.js.map